@if (portal) {
  <ng-container
    [ngTemplateOutlet]="portal"
  ></ng-container>
}
